var share = "https://shopfront-cdn.tekoapis.com/static/7c85713d791fb634.svg";

export { share as default };
